import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderCapturedByGrace from "../../../../src/content/captured-by-grace/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderCapturedByGrace,
  React
};